import React from 'react';

import { isNil } from 'lodash';
import PropTypes from 'prop-types';

import { InfoTooltip } from 'components/InfoTooltip/InfoTooltip';

import { SectionMidTitle } from './SectionMidTitle';
import { SectionSubtitle } from './SectionSubtitle';
import { SectionTitle } from './SectionTitle';

import './FormSection.sass';

export const FormSection = (props) => {
  const {
    title,
    midTitle,
    subtitle,
    infoText,
    children,
    tooltip,
    titleTooltip,
    isExtension,
    navigationTooltip,
  } = props;
  return (
    <div className={`form-section${isExtension ? '__extension' : ''}`}>
      {title && (
        <div className="form-section__title-container">
          <SectionTitle>{title}</SectionTitle>
          {titleTooltip && <InfoTooltip title={titleTooltip} />}
        </div>
      )}
      {midTitle && <SectionMidTitle>{midTitle}</SectionMidTitle>}

      {subtitle && (
        <div className="form-section__section-subtitle-container">
          <SectionSubtitle flex={Boolean(tooltip || navigationTooltip)}>{subtitle}</SectionSubtitle>
          {tooltip && <InfoTooltip title={tooltip} />}
          {!isNil(navigationTooltip) && navigationTooltip}
        </div>
      )}
      {infoText ? <div className="form-section__info-text">{infoText}</div> : null}
      {children}
    </div>
  );
};
FormSection.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  midTitle: PropTypes.string,
  subtitle: PropTypes.string,
  infoText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  tooltip: PropTypes.node,
  titleTooltip: PropTypes.node,
  isExtension: PropTypes.bool,
  navigationTooltip: PropTypes.node,
};

FormSection.defaultProps = {
  title: '',
  midTitle: '',
  subtitle: '',
  infoText: '',
  children: null,
  tooltip: null,
  titleTooltip: null,
  isExtension: false,
  navigationTooltip: null,
};
